import { render, staticRenderFns } from "./ChangeCourseCampus.vue?vue&type=template&id=d89ccec2&scoped=true&"
import script from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
export * from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeCourseCampus.vue?vue&type=style&index=0&id=d89ccec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89ccec2",
  null
  
)

export default component.exports